import { createAction } from '@reduxjs/toolkit'
import { InputThumbnailMap } from '../../thumbnail/ThumbnailFetcher'

export const onThumbnailsFetched = createAction<InputThumbnailMap>('thumbnails/onThumbnailsFetched')
